import { getUrl, sessionExpired } from "../setEnvironment";

class ParametersAPI {
  constructor() {
    this.URL = getUrl();
    this.getAllParameters = this.getAllParameters.bind(this);
    this.getParametersType = this.getParametersType.bind(this);
    this.updateParamGroup = this.updateParamGroup.bind(this);
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async getAllParameters(token) {
    try {
      const response = await fetch(
        this.URL + "/params/getAllParams",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      ).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async getParametersType(token, type) {
    try {
      const response = await fetch(
        this.URL +
          "/params/getParamsType?param_type=" +
          type,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      ).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async updateParamGroup(paramGroup, token) {
    let raw = JSON.stringify({
      params: paramGroup,
    });
    try {
      const response = await fetch(this.URL + "/params/updateParameterByName", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
}

let _parameterAPI = null;

const initParameterAPI = () => {
  if (!_parameterAPI) {
    _parameterAPI = new ParametersAPI();
  }
  return _parameterAPI;
};

const getParameterAPI = () => {
  return initParameterAPI();
};

export { initParameterAPI, getParameterAPI };
